import api from "./api";

// ============================================================================
// SERVICIOS
// ============================================================================
export const servicioService = {
  getAll: async () => {
    const response = await api.get("/servicios");
    // response.data es { servicios: [...] } después del interceptor
    const list =
      response.data?.servicios ||
      (Array.isArray(response.data) ? response.data : []);
    return Array.isArray(list) ? list : [];
  },

  getById: async (id) => {
    const response = await api.get(`/servicios?id=${id}`);
    const list =
      response.data?.servicios ||
      (Array.isArray(response.data) ? response.data : []);
    return Array.isArray(list) ? list : [];
  },

  create: async (data) => {
    const response = await api.post("/servicios", data);
    return response.data;
  },

  update: async (data) => {
    const response = await api.put("/servicios", data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete("/servicios", {
      data: { id },
    });
    return response.data;
  },
};

// ============================================================================
// PAQUETES
// ============================================================================
export const paqueteService = {
  getAll: async () => {
    const response = await api.get("/paquetes");
    // response.data es { paquetes: [...] } después del interceptor
    const list =
      response.data?.paquetes ||
      (Array.isArray(response.data) ? response.data : []);
    return Array.isArray(list) ? list : [];
  },

  getById: async (id) => {
    const response = await api.get(`/paquetes?id=${id}`);
    const list =
      response.data?.paquetes ||
      (Array.isArray(response.data) ? response.data : []);
    return Array.isArray(list) ? list : [];
  },

  create: async (data) => {
    const response = await api.post("/paquetes", data);
    return response.data;
  },

  update: async (data) => {
    const response = await api.put("/paquetes", data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete("/paquetes", { data: { id } });
    return response.data;
  },
};
